var lib_core = require("./index.js");
var UserController = require("./userController.js");
var logError  = require("./error.js");

var AppController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
    this.dataManagerConfig = null;
};
lib_core.inherit(AppController, lib_core.Controller);
AppController.inject = {
    userController : UserController
};


AppController.prototype.beforeLoadPromise = function() {
    var self = this;

    var promise = new Promise(function(resolve, reject) {
        lib_core.Controller.prototype.beforeLoad.call(self);

        self.dataManagerConfig = self.configuration.dataManagerConfig;

        var dataManager = lib_core.DataManagerClientFactory.getInstance(self.dataManagerConfig.content_server_client, self.userController);
        // self.root.attachContentServerClient(contentServerClient);

        var assetLoader = lib_core.AssetLoaderFactory.getInstance(dataManager, self.dataManagerConfig.asset_loader);
        self.root.dataLoader = assetLoader;

        var docLoader = lib_core.DocumentLoaderFactory.getInstance(self.root, dataManager, self.dataManagerConfig.document_loader, self.userController);
        // self.root.attachDocumentLoader(docLoader);

        docLoader.openDocument(self.dataManagerConfig.document_options, self.configuration.nodesToSkip)
        .then(function() {
            if(self.configuration.recorderConfig){
                // create root statemachine
                self.rootStateMachine.recorder = self.setupRecorder();
                self.rootStateMachine.recorder.setStatemachine(self.rootStateMachine);
                self.rootStateMachine.recorder.setRoots(self.root, self.archLayers.rootModel.root);
            }

            resolve("Stuff worked!");
        })
        .catch(function(error) {
            reject(error);
        });

    });

    return promise;
};

AppController.prototype.afterLoad = function() {
    lib_core.Controller.prototype.afterLoad.call(this);

    if(this.rootStateMachine.recorder){
        this.rootStateMachine.recorder.setLoaded();
    }
};

AppController.prototype.setupRecorder = function() {
    console.assert(this.configuration.recorderConfig);
    var recorderConfig = this.configuration.recorderConfig;

    var recorder = new lib_core.Recorder(recorderConfig);
    recorder.setShareId(this.dataManagerConfig.document_options.id);
    if (recorderConfig && recorderConfig.eventsAPIServer != "") {
        recorder.persist(recorderConfig.eventsAPIServer, recorderConfig.eventsAPIAFC);
    }
    if ('undefined' !== typeof window) {
        window['CircuitsRecorder'] = recorder;
    }
    return recorder;
};

module.exports =  AppController;
